import React, { useState, useEffect } from "react";
import { useMutation, useApolloClient } from "@apollo/client";
import { useNavigate, useParams } from "react-router-dom";
import { gql } from "@apollo/client";
import {
  Alert,
  Box,
  Button,
  Container,
  Divider,
  Paper,
  Snackbar,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import NumberRating from "../components/NumberRating";
import Feedback from "../components/Feedback";
import { APP_ID } from "../../../constants";

const useStyles = makeStyles({
  content: {
    padding: 10,
  },
});

const Survey = (_) => {
  let { referenceNo } = useParams();

  const classes = useStyles();
  const [survey, setSurvey] = useState();
  const [isDisabled, setIsDisabled] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [isAvailable, setisAvailable] = React.useState(-1);
  const [isFriendly, setIsFriendly] = React.useState(-1);
  const [isKnowledgeable, setIsKnowledgeable] = React.useState(-1);
  const [isProfessional, setIsProfessional] = React.useState(-1);
  const [isPaymentFast, setIsPaymentFast] = React.useState(-1);
  const [isTimely, setIsTimely] = React.useState(-1);
  const [feedback, setFeedback] = React.useState(null);

  const navigate = useNavigate();

  const GET_CUSTOMER_SURVEY = gql`
    query getSurveyByReference($referenceNo: String) {
      getSurveyByReference(referenceNo: $referenceNo)
    }
  `;

  const SET_SURVEY_BY_REF = gql`
    mutation setSurveyByReference(
      $app: String
      $identifier: String
      $reference: String
      $subIdentifier: String
      $data: JSON
    ) {
      setSurveyByReference(
        app: $app
        identifier: $identifier
        reference: $reference
        subIdentifier: $subIdentifier
        data: $data
      )
    }
  `;

  const client = useApolloClient();

  const fetchData = async () => {
    try {
      const { data, loading } = await client.query({
        query: GET_CUSTOMER_SURVEY,
        variables: { referenceNo },
        fetchPolicy: "network-only",
      });

      if (!loading) {
        let mySurvey = data.getSurveyByReference;
        setSurvey(mySurvey);
        if (mySurvey.survey.data) {
          const {
               isAvailable,
               isFriendly,
               isKnowledgeable,
               isProfessional,
               isPaymentFast,
               isTimely,
               feedback,
          } = mySurvey.survey.data

          setIsDisabled(true)
          setisAvailable(isAvailable)
          setIsFriendly(isFriendly)
          setIsKnowledgeable(isKnowledgeable)
          setIsProfessional(isProfessional)
          setIsPaymentFast(isPaymentFast)
          setIsTimely(isTimely)
          setFeedback(feedback)
        }
      }
    } catch (err) {
      navigate("/ops");
    }
  };

  const [setSurveyByReference] = useMutation(SET_SURVEY_BY_REF);
  const doSubmitSurvey = async () => {
    if (
      isAvailable === -1 ||
      isFriendly === -1 ||
      isKnowledgeable === -1 ||
      isProfessional === -1 ||
      isPaymentFast === -1 ||
      isTimely === -1
    ) {
      setOpenAlert(true);
    } else {
      const { data } = await setSurveyByReference({
        variables: {
          app: APP_ID,
          identifier: survey._id,
          data: {
            isAvailable,
            isFriendly,
            isKnowledgeable,
            isProfessional,
            isPaymentFast,
            isTimely,
            feedback,
          },
          reference: "ACE C&C Survey v2",
          subIdentifier: survey.branchId,
        },
      });
      
      if (data) {
        const { _id } = data.setSurveyByReference;
        navigate(`/thankyou/${_id}`);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Container maxWidth="md" className={classes.content}>
      {survey && (
        <Paper elevation={0}>
          <h3>Hi {survey.firstName ? survey.firstName.toUpperCase() : ""}!</h3>
          {isDisabled ? (
            <h3>Thank you for shopping at Ace Hardware!</h3>
          ) : (
            <h3>
              We value your feedback. We appreciate if you can take a moment to
              answer this survey.
            </h3>
          )}
          <Divider />
          <NumberRating
            question="All items you inquired are available?"
            disabled={isDisabled}
            name="isAvailable"
            value={isAvailable}
            setValue={setisAvailable}
          />
          <Divider />
          <NumberRating
            question="Call to deliver sales rep is friendly and helpful?"
            disabled={isDisabled}
            name="isFriendly"
            value={isFriendly}
            setValue={setIsFriendly}
          />
          <Divider />
          <NumberRating
            question="Call to deliver sales rep is knowledgeable about your inquiry (product, price, promotions, etc)?"
            disabled={isDisabled}
            name="isKnowledgeable"
            value={isKnowledgeable}
            setValue={setIsKnowledgeable}
          />
          <Divider />
          <NumberRating
            question="The order process was handled professionally?"
            disabled={isDisabled}
            name="isProfessional"
            value={isProfessional}
            setValue={setIsProfessional}
          />
          <Divider />
          <NumberRating
            question="The payment process was fast?"
            disabled={isDisabled}
            name="isPaymentFast"
            value={isPaymentFast}
            setValue={setIsPaymentFast}
          />
          <Divider />

          <NumberRating
            question="The promotions were timely and attractive?"
            disabled={isDisabled}
            name="isTimely"
            value={isTimely}
            setValue={setIsTimely}
          />
          <Divider />

          <Feedback
            disabled={isDisabled}
            name="feedback"
            value={feedback}
            setValue={setFeedback}
          />

          {!isDisabled ? (
            <Box textAlign="center">
              <Button variant="contained" onClick={() => doSubmitSurvey()}>
                Submit
              </Button>{" "}
            </Box>
          ) : null}
        </Paper>
      )}
      <Snackbar
        open={openAlert}
        autoHideDuration={3000}
        onClose={() => setOpenAlert(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={() => setOpenAlert(false)} severity="error">
          Please complete our survey before submitting
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default Survey;
